import React from "react";
import { CircularProgress } from "@material-ui/core";
import "./SubmitButton.css";

interface SubmitButtonProps {
  onClick: () => void;
  disabled?: boolean;
  icon?: React.ReactNode;
  type?: "primary" | "secondary";
  isLoading?: boolean;
  children: React.ReactNode;
  dataCy?: string;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  onClick,
  disabled = false,
  icon,
  type = "primary",
  isLoading = false,
  children,
  dataCy,
}) => {
  return (
    <button
      className={`submitButton--${type}`}
      onClick={onClick}
      disabled={disabled}
      type="button"
      data-cy={dataCy}
      data-cypress-id={`submit-button-${type}`}
    >
      {isLoading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        <>
          {icon && <span className="submitButton__icon">{icon}</span>}
          <span className="submitButton__text" data-cypress-id={`submit-button-text-${type}`}>
            {children}
          </span>
        </>
      )}
    </button>
  );
};
